import { Breadcrumbs, BreadcrumbItem } from '@heroui/react';
import { Link } from 'react-router-dom';

export default function Breadcrumb({
  items,
}: {
  items?: { label: string; href: string }[];
}) {
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <Breadcrumbs>
      {items?.map((item, index) => (
        <BreadcrumbItem key={index}>
          <Link to={item.href}>{item?.label}</Link>
        </BreadcrumbItem>
      ))}
    </Breadcrumbs>
  );
}
